import { postRequest } from "./request";

export function ClientListOnload(dataObject) {
  const userData = JSON.parse(localStorage.getItem("userData"));
  return postRequest({
    path: `get-client-details`,
    token: userData.token,
  }).then((response) => {
    return response ? response : undefined;
  });
}
